import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getErrors, getErrorById, resolveError, getAffectedDevices } from '@/api/endpoints/errors';

interface UseErrorsOptions {
  status?: string;
  severity?: string;
  dateRange?: {
    start: string;
    end: string;
  };
  page?: number;
  limit?: number;
}

export const useErrors = (options?: UseErrorsOptions) => {
  return useQuery({
    queryKey: ['errors', options],
    queryFn: () => getErrors(options),
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
};

export const useError = (id: string) => {
  return useQuery({
    queryKey: ['error', id],
    queryFn: () => getErrorById(id),
    staleTime: 1000 * 60 * 5,
    retry: 0,
    enabled: !!id,
  });
};

export const useResolveError = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, notes }: { id: string; notes?: string }) => resolveError(id, notes),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['errors'] });
      queryClient.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
};

export const useAffectedDevices = (errorId: string) => {
  return useQuery({
    queryKey: ['affectedDevices', errorId],
    queryFn: () => getAffectedDevices(errorId),
    staleTime: 1000 * 60 * 5,
    retry: 0,
    enabled: !!errorId,
  });
};
